<template>
  <div>
    <CrudList
      title="Companies"
      storeName="Companies"
      :canAdd="role && role === 'admin' ? true : false"
      :canEdit="true"
      :canDelete="role && role === 'admin' ? true : false"
      sortable
      canSearch
    >
      <template v-slot:picture="{ item }">
        <v-row align="center" justify="center">
          <v-col cols="12">
            <v-list-item-avatar v-if="item.picture">
              <img :src="item.picture" alt="" />
            </v-list-item-avatar>
          </v-col>
        </v-row>
      </template>
      <template v-slot:regions="{ item }">
        <v-btn
          v-if="
            role && (role === 'admin' || role === 'admin_enterprise')
              ? true
              : false
          "
          color="primary"
          @click="$router.push('/admin/companies/' + item.id + '/regions')"
          >Regions
        </v-btn>
      </template>
      <template v-slot:member_actions="{ item }">
        <v-btn
          v-if="
            role && (role === 'admin' || role === 'admin_enterprise')
              ? true
              : false
          "
          color="warning"
          @click="
            $router.push('/admin/companies/' + item.id + '/member_affiliations')
          "
          >Memberships
        </v-btn>
      </template>
      <template v-slot:products="{ item }">
        <v-btn
          color="primary"
          @click="$router.push('/admin/companies/' + item.id + '/products')"
          >Products
        </v-btn>
      </template>
      <template v-slot:modal_delete_item="{ show, hide, submit }">
        <DeleteConfirm
          :show="show"
          :hide="() => hide_modal(hide)"
          title="Delete Company"
          description="Are you sure to delete this company?"
        >
          <template v-slot="{ close }">
            <ValidationObserver
              ref="validator_delete"
              v-slot="{ validate, errors }"
            >
              <form @submit.prevent="validate().then(verifiedPassword(submit))">
                <p>Are you sure to delete this company?</p>
                <v-row>
                  <v-col>
                    <ValidationProvider
                      vid="password"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        :error-messages="errors"
                        v-model="data.password"
                        label="Password"
                        prepend-inner-icon="fas fa-lock"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <v-row style="padding: 0; margin: 0">
                  <v-col class="text-center" style="padding: 0; margin: 0">
                    <v-btn
                      color="gray"
                      rounded
                      elevation="0"
                      @click="close"
                      class="mr-5"
                      >Cancel
                    </v-btn>

                    <v-btn
                      color="primary"
                      type="submit"
                      rounded
                      elevation="0"
                      :loading="status == 'loading'"
                      >Confirm
                    </v-btn>
                  </v-col>
                </v-row>
              </form>
            </ValidationObserver>
          </template>
        </DeleteConfirm>
      </template>
    </CrudList>
  </div>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";
import { mapActions, mapState } from "vuex";
import DeleteConfirm from "@/components/Crud/Modals/ConfirmValidation";
import { ValidationProvider, ValidationObserver } from "vee-validate";
export default {
  components: {
    CrudList,
    DeleteConfirm,
    ValidationObserver,
    ValidationProvider
  },
  computed: {
    ...mapState({
      role: state => state.Authenticate.role
    })
  },
  data() {
    return {
      data: {
        password: ""
      },
      status: ""
    };
  },
  async created() {
    const self = this;
    await self.$store.dispatch("Authenticate/me");
  },
  methods: {
    ...mapActions({
      verifiedPass: "Authenticate/verifiedPassword"
    }),
    hide_modal(hide) {
      if (this.$refs && this.$refs.validator_delete) {
        this.data.password = "";
        this.$refs.validator_delete.reset();
        hide();
      }
    },
    async verifiedPassword(next_submit) {
      const self = this;
      const is_validate = await this.$refs.validator_delete.validate();
      if (is_validate) {
        await this.verifiedPass(this.data.password)
          .then(resp => {
            next_submit();
          })
          .catch(e => {
            this.$refs.validator_delete.setErrors({
              password: ["invalid password"]
            });
          });
      }
    }
  }
};
</script>
